<template>
    <div>
        <!-- Modal confirm mail -->
        <modal name="modal-confirm-mail" height="auto" :scrollable="true">
            <div class="p-4">
                <div class="text-lg font-bold mb-4">Confirmation de l'adresse email</div>
                <p class="text-sm font-light">Merci de saisir l'adresse email de votre magasin ci-dessous</p>
                <div>{{ hideMail }}</div>
                <input placeholder="Adresse email" class="border bg-gray-50 text-sm rounded-lg block w-full p-2.5 focus:outline-none mt-4" type="email" v-model="confirmMail" :label-inline="false" />
                <button :disabled="loadingSendDsc" @click="sendSuivi" class="px-4 py-2 rounded mt-4 bg-emerald-800 text-white">
                    <spinner v-if="loadingSendDsc" :size="10" />
                    <template v-if="!loadingSendDsc">
                        <i class="fas fa-check mr-2"></i> Valider
                    </template>
                </button>
            </div>
        </modal>

        <div class="max-w-[400px]">
            <div class="p-4 bg-slate-800 text-white rounded-t text-sm font-bold"><i class="fas fa-comments mr-1"></i> Assistance</div>
            <div ref="chatContainer" class="border max-h-[500px] overflow-y-auto">
                <div
                    class="bg-white border-b border-slate-600"
                    v-for="(messagesList, index) in messagesLists"
                    :key="'message-list-' + index"
                >
                    <!-- Message système -->
                    <div class="p-4 flex items-center gap-2">
                        <i class="fa-solid fa-message"></i>
                        <p class="p-4" v-html="messages[messagesList].content"></p>
                    </div>

                    <!-- Boutons seulement sur le dernier message -->
                    <template v-if="!isTyping && index === messagesLists.length - 1">
                        <div class="mb-4 px-14">
                            <button
                                v-for="(button, btnIndex) in messages[messagesList].buttons"
                                :key="'button-' + btnIndex"
                                class="w-full bg-emerald-600 hover:bg-emerald-700 duration-200 text-white text-sm px-4 py-2 rounded mr-2 mb-2"
                                @click="handleUserClick(button.text, button.action)"
                            >
                                {{ button.text }}
                            </button>
                        </div>
                    </template>

                    <!-- Réponse utilisateur, si existante -->
                    <div v-if="userResponses[index]" class="p-4 bg-slate-100 border-t text-sm border-slate-600">
                        <div class="font-bold flex items-center gap-2">
                            <i class="fas fa-user mr-1"></i>
                            <p class="p-4">{{ userResponses[index] }}</p>
                        </div>
                    </div>
                </div>

                <!-- Spinner -->
                <div class="border-t border-slate-600 p-4" v-if="isTyping">
                    <spinner :size="10" />
                </div>

                <div v-if="displayFormSuivi">
                    <div class="p-4 flex items-center gap-2 bg-slate-100">
                        <i class="fas fa-message"></i>
                        <div class="p-4 grow" v-if="!sendedDsc">
                            <div class="font-bold text-sm mb-0.5">Numéro WCA</div>
                            <input class="border bg-gray-50 text-sm rounded-lg block w-full p-2.5 focus:outline-none" type="text" v-model="numDsc" :label-inline="false" />
                            <button :disabled="loadingGetMail" class="px-4 py-2 bg-emerald-700 hover:bg-emerald-800 duration-200 text-white rounded text-sm mt-2" @click="getMail">
                                <spinner :size="10" v-if="loadingGetMail" />
                                <template v-if="!loadingGetMail">
                                    <i class="fas fa-check mr-1"></i> Accéder au suivi
                                </template>
                            </button>
                        </div>
                        <div class="p-4 grow" v-if="sendedDsc">
                            <div class="bg-green-100 p-4 rounded">
                                <div class="font-bold text-sm mb-0.5">Votre demande a bien été envoyée</div>
                                <div>Un email de confirmation vous a été envoyé pour accéder au suivi de votre dossier.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiService from '@/services/api.service'

export default {
    data() {
        return {
            isTyping: false,
            messagesLists: [1],
            userResponses: [],
            messages: {
                1: {
                    content: "Notre plateforme agit en tant qu’intermédiaire entre les différents acteurs du service après-vente.<div class='mt-2 font-bold text-orange-600'><i class='fas fa-exclamation-triangle mr-1'></i> Nous ne traitons pas directement vos demandes. Celles-ci sont traitées par vos divers fournisseurs</div>",
                    buttons: [
                        {
                            text: "Commencer l'assistance",
                            action: () => this.addMessage(2)
                        }
                    ]
                },
                2: {
                    content: "Pour accéder au suivi détaillé de votre dossier, connectez-vous à votre compte.",
                    buttons: [
                        {
                            text: "Me connecter à mon compte",
                            action: () => this.addMessage(9)
                        },
                        {
                            text: "Je ne parviens plus à me connecter",
                            action: () => this.addMessage(3)
                        },
                        {
                            text: "Je n’ai pas encore de compte",
                            action: () => this.addMessage(4)
                        }
                    ]
                },
                3: {
                    content: "Vous pouvez récupérer l’accès à votre compte en toute autonomie via notre page dédiée :<br><a href='https://auth.districloud.net/mot-de-passe-oublie' target='_blank' class='text-emerald-600 underline hover:text-emerald-800'>Réinitialiser mon mot de passe</a>",
                    buttons: [
                        {
                            text: "Je ne connais pas mon identifiant",
                            action: () => this.addMessage(5)
                        }
                    ]
                },
                4: {
                    content: "<p>Pour avoir un meilleur suivi de vos dossiers et consulter l’historique de vos échanges, créez votre compte en quelques clics depuis notre <a href='https://auth.districloud.net/inscription' target='_blank' class='text-emerald-600 underline hover:text-emerald-800'>portail d’inscription</a>.</p>",
                    buttons: [
                        {
                            text: "Comment créer un compte ?",
                            action: () => this.addMessage(7)
                        },
                        {
                            text: "Suivi de dossier unitaire",
                            action: () => this.addMessage(6)
                        }
                    ]
                },
                5: {
                    content: "Si vous ne retrouvez pas votre identifiant, vous pouvez procéder à une nouvelle inscription ici :<br><a href='https://auth.districloud.net/inscription' target='_blank' class='text-emerald-600 underline hover:text-emerald-800'>Créer un nouveau compte</a>",
                    buttons: []
                },
                6: {
                    content: "Pour profiter pleinement de notre service de suivi, la création d’un compte est vivement recommandée.",
                    buttons: [
                        {
                            text: "Créer un compte maintenant",
                            action: () => this.addMessage(7)
                        },
                        {
                            text: "Je souhaite accéder sans compte",
                            action: () => this.addMessage(8)
                        }
                    ]
                },
                7: {
                    content: "Pour créer un compte sur Districloud, vous devez suivre les étapes suivantes :<div class='mt-2'>1. Rendez-vous sur <a href='https://auth.districloud.net/inscription' target='_blank' class='text-emerald-700 underline hover:text-emerald-900'>https://auth.districloud.net/inscription</a><br>2. Sélectionnez <span class='font-semibold'>Magasins</span> comme type d’inscription<br>3. Choisissez votre <span class='font-semibold'>pays</span><br>4. Sélectionnez votre <span class='font-semibold'>secteur d’activité</span><br>5. Identifiez votre <span class='font-semibold'>centrale d’achat</span> (si applicable)<br>6. Saisissez votre <span class='font-semibold'>numéro de SIRET</span> <span class='text-sm text-gray-600'>(à retrouver sur <a href='https://pappers.fr' target='_blank' class='text-emerald-700 underline hover:text-emerald-900'>pappers.fr</a>)</span><br>7. Remplissez votre <span class='font-semibold'>fiche magasin</span><br>8. Créez votre <span class='font-semibold'>compte utilisateur</span></div><div class='mt-4 text-sm font-light text-orange-600'><i class='fas fa-clock mr-1'></i> Une fois votre demande complétée, nos administrateurs procéderont à la validation de votre compte dans les plus brefs délais.</div>",
                    buttons: []
                },

                8: {
                    content: "Si vous préférez ne pas créer de compte, vous pouvez accéder à votre dossier ponctuellement via le formulaire ci-dessous.",
                    buttons: []
                },
                9: {
                    content: "Pour vous connecter, rendez-vous ici :<br><a href='https://districloud.net' target='_blank' class='text-emerald-600 underline hover:text-emerald-800'>Page de connexion</a>",
                    buttons: [
                        {
                            text: "Je ne parviens plus à me connecter",
                            action: () => this.addMessage(3)
                        },
                        {
                            text: "Je n’ai pas encore de compte",
                            action: () => this.addMessage(4)
                        }
                    ],
                    action: () => {
                        window.location.href = 'https://districloud.net';
                    }
                }
            },

            displayFormSuivi: false,
            numDsc: null,
            sendedDsc: false,
            loadingGetMail: false,
            loadingSendDsc: false,
            hideMail: '',
            confirmMail: ''
        };
    },
    methods: {
        addMessage(messageId) {
            this.isTyping = true;
            // execute action
            if (this.messages[messageId].action) {
                this.messages[messageId].action();
            }
            setTimeout(() => {
                this.isTyping = false;
                this.messagesLists.push(messageId);

                if (messageId == 8) {
                    this.displayFormSuivi = true;
                }

                this.$nextTick(() => {
                    this.scrollToBottom(); // Scroll à la fin
                })
            }, 1000);
        },
        handleUserClick(userText, action) {
            // Enregistre la réponse utilisateur à cet index
            this.userResponses.push(userText);
            action();
        },

        scrollToBottom() {
            this.$nextTick(() => {
                const container = this.$refs.chatContainer;
                if (container) {
                    container.scrollTop = container.scrollHeight;
                }
            });
        },

        async getMail() {
            if (!this.numDsc) {
                this.$toast.error('Veuillez saisir votre numéro de WCA');
                return;
            }
            
            this.loadingGetMail = true
            let response = await apiService.post('suivi.get-mail-suivi', { num_dsc: this.numDsc });
            this.loadingGetMail = false
            
            this.hideMail = response.data.posts.post;
            this.$modal.show('modal-confirm-mail')
        },

        async sendSuivi() {
            if (!this.confirmMail) {
                this.$toast.error('Veuillez saisir l\'adresse email de votre magasin');
                return;
            }
            if (!this.confirmMail.includes('@')) {
                this.$toast.error('Veuillez saisir une adresse email valide');
                return;
            }
            this.loadingSendDsc = true
            let responseConfirm = await apiService.post('suivi.confirm-mail', { num_dsc: this.numDsc, email_confirm: this.confirmMail });
            if (responseConfirm.data.posts.post != 1) {
                this.$toast.error('Adresse email invalide');
                this.loadingSendDsc = false
                return;
            }
            let response = await apiService.post('suivi.send-mail-suivi', { num_dsc: this.numDsc })
            if (response.data.posts.post == 1) {
                this.$toast.success('Votre demande a bien été envoyée')
                this.numDsc = ''
                this.sendedDsc = 1
                this.$modal.hide('modal-confirm-mail')
            } else {
                this.$toast.error('Une erreur est survenue lors de l\'envoi de votre demande')
            }
            this.loadingSendDsc = false
        }
    },
    mounted() {
    }
};
</script>
